import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core'
import DropDownForDurations from './DropDownDurations'
import { useDispatch, useSelector } from 'react-redux'
import { getStaffs, getStaffsGenReg, setAdditionalComments, setAnalysisArray, setRecurrenceRule, setSelectedDuration, setSelectedTimeRange, setSelectedTimeRangeForUIShow, setTimetimeRangeSelectionForDropDown } from '../../../redux/reducers/createOrderSlice'
import { LocalizationProvider, DateCalendar, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TextField } from '@mui/material'
import { changeTimeFromMioToNormal, convertHtmlTimeToMui, isBeforeApril1st2024 } from '../../../utils/createOrderCommonFunctions'
import dayjs from "dayjs";
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import DropDownForDayNight from './DropDownForDayNight'
import { loadingContentForStaffAvailability, timeSelectionArrayForDay, timeSelectionArrayForNight } from '../../../utils/constants'
import DropDownForTimeSelection from './DropDownForTimeSelection'
import { setLoadingContent } from '../../../redux/reducers/loadingSlice'
import { getMonthlyBlockDates } from '../../../redux/reducers/myOrdersSlice'
export const durations = [3, 4, 5, 6, 7, 8, 9];
const GeneralServiceOrder = () => {
  // hooks 
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [error, setError] = useState(false)
  // stores call
  const { selectedEndDate,
    selectedStartDate,
    selectedService,
    selectedDuration,
    selectedAddress,
    preferredStaffs,
    hasStaffAvailable,
    additionalComments,
    dayNightOptionsForUi,
    recurrenceRule,
    timeRangeSelectionForDropDown,
    priceDetails } = useSelector((state) => state.createOrderSlice)
  const { companyBlockDates } = useSelector((state) => state.orders)
  // states 
  const [endValue, setEndValue] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false)
  const [date, setDate] = useState(selectedStartDate ?? "");

  // functions
  const changeTime = (value) => {
    const time = new Date(value)
    const hours = time.getHours();
    const minutes = time.getMinutes();

    // Convert the time to the format HH:mm
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    // var [hours, minutes] = value.split(":");
    setEndValue(
      `${Number(hours) + Number(selectedDuration) > 23
        ? Number(hours) + Number(selectedDuration) - 24
        : Number(hours) + Number(selectedDuration)
      }:${minutes}`
    );
    let existingDate = new Date(date);
    existingDate.setHours(parseInt(hours));
    existingDate.setMinutes(parseInt(minutes));
    let endTime = new Date(date);
    endTime.setHours(
      parseInt(Number(hours) + Number(selectedDuration))
    );
    endTime.setMinutes(parseInt(minutes));
    dispatch(
      setSelectedTimeRange({
        selectedStartDate: existingDate.toISOString(),
        selectedEndDate: endTime.toISOString(),
      })
    );
  };

  const changeDuration = (e, day) => {
    if (!!selectedEndDate) {
      let startDate = new Date(selectedStartDate)
      startDate.setHours(startDate.getHours() + e.target.value)
      dispatch(setSelectedTimeRange({ selectedStartDate: selectedStartDate, selectedEndDate: startDate.toISOString() }))
      setEndValue(
        `${(startDate.getHours()) > 23
          ? (startDate.getHours()) - 24
          : (startDate.getHours())
        }:${startDate.getMinutes()}`
      );
    }
    dispatch(setSelectedDuration({ selectedDuration: e.target.value }));
  };

  const gettingStaffs = () => {
    dispatch(setLoadingContent(loadingContentForStaffAvailability))
    dispatch(getStaffsGenReg({
      values: {
        location: selectedAddress?.location,
        orderType: "General",
        svcStartDate: selectedStartDate,
        svcEndDate: selectedEndDate,
        staffNeeded: 1,
        preferredStaffs: preferredStaffs,
        serviceArray: selectedService?.map((item, index) => {
          return {
            serviceId: item?._id,
            duration: selectedDuration,
            position: index + 1,
            "staff": "",
            startDate: selectedStartDate,
            endDate: selectedEndDate,
          };
        }),
      },
      dispatch: dispatch
    }))
  }

  const gotoNextPage = () => {
    if (!agreeTerms) {
    toast.error("Please confirm that you understand the cleaning supplies policy.");
    return;
  }
    // if (!hasStaffAvailable) {
    //   console.log(selectedEndDate,'selectedEndDate')
    //   setError(true)
    //   // toast.error("Please select required field")
    // }
    // else
    if (selectedEndDate && selectedService?.length) {
      navigate('/checkout')
    }
    else {
      toast.error("Please choose the time")
    }
  }

  const recurrenceRuleSet = (data) => {
    dispatch(setRecurrenceRule({ recurrenceRule: { ...recurrenceRule, ...data } }))
    setDate('')
  }

  const handleGenerate = () => {

    const result = [];
    const timeIntervals = recurrenceRule?.timePreference?.includes('Day') ?
      timeSelectionArrayForDay(+selectedDuration) : timeSelectionArrayForNight(+selectedDuration)    // for(let i=0; i<selectionArr.length; i++){
    const duration = { hours: selectedDuration, minutes: 0, seconds: 0 };
    for (let i = 0; i < timeIntervals.length; i++) {
      const startTime = timeIntervals[i];
      const endTime = {
        hours: startTime.hours + duration.hours,
        minutes: startTime.minutes + duration.minutes,
        seconds: startTime.seconds + duration.seconds,
      };
      result.push({ startTime, endTime, id: `timeRange-${i + 1}` });
    }
    if (result.length > 0) {
      dispatch(setTimetimeRangeSelectionForDropDown({ timeRangeSelectionForDropDown: result }))
    }

  }

  // useEffects
  useEffect(() => {
    if (
      selectedStartDate &&
      selectedEndDate &&
      selectedDuration
    ) {
      // gettingStaffs();
    }
  }, [

    selectedStartDate,
    selectedEndDate,
    selectedDuration,
  ]);

  useEffect(() => {
    if (selectedStartDate && selectedEndDate && date) {
      let startDate = new Date(selectedStartDate)
      startDate.setDate(new Date(date).getDate())
      startDate.setMonth(new Date(date).getMonth())
      startDate.setFullYear(new Date(date).getFullYear())
      let endDate = new Date(selectedEndDate)
      endDate.setDate(new Date(date).getDate())
      endDate.setMonth(new Date(date).getMonth())
      endDate.setFullYear(new Date(date).getFullYear())
      dispatch(setSelectedTimeRange({ selectedStartDate: startDate.toISOString(), selectedEndDate: endDate.toISOString() }))
    }
  }, [date])

  useEffect(() => {
    if (selectedStartDate) {
      document.getElementById('date-picker-general').value = selectedStartDate
    }
  }, [selectedStartDate])
  useEffect(() => {
    handleGenerate()
  }, [selectedDuration])
  useEffect(() => {
    let startDate = selectedStartDate ? new Date(selectedStartDate) : new Date()
    startDate.setDate(startDate.getDate() + 2)
    startDate.setDate(1)
    let endDate = selectedStartDate ? new Date(selectedStartDate) : new Date()
    endDate.setDate(endDate.getDate() + 2)
    endDate.setDate(31)
    dispatch(getMonthlyBlockDates({
      currentPage: 1,
      limit: 31,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    }))
    if (selectedStartDate) {
      setDate(selectedStartDate)
    }
  }, [])
  const handleMonthChange = (data) => {
    let endDate = new Date(data)
    endDate.setDate(31)
    dispatch(getMonthlyBlockDates({
      currentPage: 1,
      limit: 31,
      startDate: new Date(data).toISOString(),
      endDate: endDate.toISOString()
    }))
  }
  const handleBlockDates = (date) => {
    let blockDate = companyBlockDates?.map(item => item?.startDate)
    for (let day of blockDate) {
      if ((new Date(day).getDate() === new Date(date).getDate()) && (new Date(day).getMonth() === new Date(date).getMonth())) {
        return true
      }
    }
  }
  return (
    <>
      <div className="form-select-s max-720">
        <div className="row">
          <div className="col-md-6">
            <DropDownForDayNight
              label={"Day/Night Session"}

              options={dayNightOptionsForUi}
              recurrenceRuleSet={recurrenceRuleSet}
              selectedDays={[""]}
              selectedService={selectedService}
              error={error}
            />
          </div>
          <div className="col-md-6">
            <DropDownForDurations
              label={"Hours  for each cleaning session?"}
              options={recurrenceRule?.timePreference === "Night Session" ? [3, 4] : durations}
              onChange={(e) => changeDuration(e, "Day")}
              optionsExtraText={recurrenceRule?.timePreference === "Night Session" ? `$${selectedService &&
                selectedService[0]?.ratePerServiceNight}/hr` : `$${selectedService &&
                selectedService[0]?.ratePerService}/hr`}
              error={error}
            />
          </div>
        </div>
      </div>


      <div className="datepicker-wrap max-720">
        <div className="row align-items-center">
          <div className="col-md-6">
            <p>Select a date and time for your first session: *</p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                shouldDisableDate={handleBlockDates}
                onMonthChange={handleMonthChange}
                onChange={(newValue) => {
                  setDate(new Date(newValue).toISOString())
                }
                }
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
                minDate={isBeforeApril1st2024() ? dayjs(new Date('2024-04-01T00:00:00.000')) : dayjs(new Date().setDate(new Date().getDate() + 2))}
                id="date-picker-general"
                disabled={!selectedDuration}
                value={selectedStartDate && dayjs(selectedStartDate)}
                renderInput={(params) => (
                  <TextField {...params} className={`!p-0`} />
                )}
              />
            </LocalizationProvider>
            {error ? !date && <p className='form-error-message'>This field is required</p> : null}

          </div>
          <div className="col-md-6">
            <div className="time-wrap">
              <p className="text-center">Timing Available *</p>
              <div className="time-pick-wrap">
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    disabled={!date}
                    ampm={false}
                    minutesStep={15}
                    value={selectedStartDate && dayjs(selectedStartDate)}
                    slotProps={{
                      textField: {
                        readOnly: true,
                      },
                    }}
                    onChange={(e) =>
                      changeTime(e)
                    }
                    renderInput={(params) => <TextField
                      {...params}
                    />}
                    minTime={recurrenceRule?.timePreference?.includes('Day') ? dayjs().set('hour', 8).set("minute", 0) : dayjs().set('hour', 18).set("minute", 0)}
                    maxTime={recurrenceRule?.timePreference?.includes('Day') ? dayjs().set('hour', 18 - selectedDuration).set("minute", 0) : dayjs().set('hour', (22 - selectedDuration)).set("minute", 0)}
                  />
                </LocalizationProvider> */}
                <DropDownForTimeSelection
                  options={timeRangeSelectionForDropDown}
                  onChange={(val) => {
                    dispatch(setSelectedTimeRangeForUIShow(val))
                    changeTime(new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString())
                  }
                  }
                  disableCondition={!date}
                  error={error}
                />
                {/* {error ? !selectedStartDate && <p className='form-error-message'>This field is required</p> : null} */}
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    disabled
                    ampm={false}
                    value={selectedEndDate ? dayjs(selectedEndDate) : convertHtmlTimeToMui(endValue)}
                    renderInput={(params) => <TextField {...params} />}
                    slotProps={{
                      textField: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider> */}
              </div>
            </div>
          </div>
        </div>

        <div className="remark-sec">

          <div className="textarea-bottom">
            <label >Additional instruction or remark:</label>
            <textarea className="form-control" value={additionalComments} onChange={(e) =>
              dispatch(
                setAdditionalComments({ additionalComments: e.target.value })
              )
            }></textarea>

            <div className="form-check mt-2">
              <input
                type="checkbox"
                id="agreeTerms"
                className="form-check-input"
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
              />
              <label htmlFor="agreeTerms" className="form-check-label additional-text mt-0">
                I understand that general / regular cleaning does not include cleaning supplies.
              </label>
            </div>
          </div>
          <div className="button-right">
            <button onClick={() => gotoNextPage()} className="btn">
              Next
              <FontAwesomeIcon icon={icon({ name: "angle-right" })} />
            </button>
          </div>

        </div>
      </div>
    </>
  )
}

export default GeneralServiceOrder